import { useQuery } from "@tanstack/react-query";

/** The voice engine the super admin chose in Admin -> Global Settings (Amazon Nova Sonic unless set to ElevenLabs). */
export function useVoiceEngine(): { novaSelected: boolean; loaded: boolean } {
  const { data } = useQuery<{ provider: string }>({ queryKey: ["/api/public/voice-provider"], staleTime: 30_000 });
  return { novaSelected: data?.provider === "nova-sonic", loaded: !!data };
}

/**
 * With Nova Sonic selected, agents that run on ElevenLabs are hidden. `alsoKeep` lists agent ids that must stay
 * visible anyway, such as the agent an existing campaign already uses, so its dropdown never goes blank.
 */
export function visibleAgents<T extends { id: string; voiceProvider?: string | null }>(
  agents: T[],
  novaSelected: boolean,
  alsoKeep: Array<string | null | undefined> = [],
): T[] {
  if (!novaSelected) return agents;
  const keep = new Set(alsoKeep.filter((id): id is string => !!id));
  return agents.filter((a) => a.voiceProvider === "nova-sonic" || keep.has(a.id));
}
